import ImageComponent from 'components/image/ImageComponent';
import React, { Component } from 'react';
import { MessageSourceProps, withMessages } from 'react-message-source';
import { Modal } from 'semantic-ui-react';
import styled from 'styled-components';

interface Props extends MessageSourceProps {
  mainSrc: string,
  prevSrc: string,
  nextSrc: string,
  mainSrcThumbnail: string,
  prevSrcThumbnail: string,
  nextSrcThumbnail: string,
  onMovePrevRequest: (event: any) => void,
  onMoveNextRequest: (event: any) => void,
  onCloseRequest?: (event: any) => void,
  imageTitle: React.ReactNode,
  imageCaption: React.ReactNode,
  toolbarButtons: Array<React.ReactNode>,
}

const StyledModal = styled(Modal)`
  height: 100% !important;
  width: 100% !important;
  margin: 0 !important;

  &.ui.modal.active {
    position: absolute;
    top: 0;
  }
`;

const StyledModalContent = styled(Modal.Content)`
  padding: 0 !important;
  height: 100% !important;
  background: transparent !important;

  .ui.inline.loader.active.send-email-in-progress {
    margin-top: -0.25rem;
    margin-left: 0.375rem;
  }
`;


class FullScreenLightBox extends Component<Props> {

  static defaultProps = {
    imageCaption: null,
    mainSrcThumbnail: null,
    nextSrcThumbnail: null,
    prevSrcThumbnail: null,
    fullScreenDisplay: false,
  }

  constructor(props: Props) {
    super(props);
  }

  render() {
    const {
      imageTitle,
      nextSrc,
      prevSrc,
      toolbarButtons,
      imageCaption,
      onCloseRequest,
      onMovePrevRequest,
      onMoveNextRequest
    } = this.props;

    return (
        <StyledModal
            open={true}
            closeOnDimmerClick={false}
            onClose={onCloseRequest ? onCloseRequest : undefined}
        >
          <StyledModalContent>
            <ImageComponent
                mainSrc={this.props.mainSrc}
                onCloseRequest={this.props.onCloseRequest}
                nextSrc={nextSrc}
                prevSrc={prevSrc}
                imageTitle={imageTitle}
                imageCaption={imageCaption}
                onMovePrevRequest={onMovePrevRequest}
                onMoveNextRequest={onMoveNextRequest}
                toolbarButtons={toolbarButtons}
            />
          </StyledModalContent>
        </StyledModal>
    )
  }
}

export default withMessages(FullScreenLightBox);
